import { render, staticRenderFns } from "./PelaporanKinerja.vue?vue&type=template&id=0bc72c7c&"
import script from "./PelaporanKinerja.vue?vue&type=script&lang=js&"
export * from "./PelaporanKinerja.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports